// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/icons/common/document.svg?inline");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".s-document{max-width:766px;display:inline-flex;padding-left:24px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position-y:4px;background-repeat:no-repeat;background-size:16px}@media (max-width:767px){.s-document{background-position-y:2px}}.s-document:hover{color:#c93d44}", ""]);
// Exports
module.exports = exports;
